function showModal(data) {
    if (!Q3.modalWrap) {
        Q3.modalWrap = $('<div style="display: none" class="modal-wrap"></div>');
        let overlay = $('<div class="overlay"></div>');
        let close = $('<div class="close"></div>');
        let modal = $('<div class="modal"><div class="modal-content"></div></div>');
        $(Q3.container.parentElement).append(Q3.modalWrap.append(overlay, modal.append(close)));
        overlay.click(closeModal);
        close.click(closeModal);
    }
    let modalContent = Q3.modalWrap.find('.modal-content');
    modalContent.html("").append('<h2>' + data.heading + '</h2>' + (data.definition ? '<h4>' + data.definition + '</h4>' : '') + data.content);
    Q3.modalWrap.fadeIn(200);

    function closeModal() {
        Q3.modalWrap.fadeOut(200);
    }
}

export default showModal;
export { showModal };